import SimpleKeyboard from './components/Keyboard';
export default SimpleKeyboard;



// WEBPACK FOOTER //
// ./src/lib/index.js